import { render, staticRenderFns } from "./PartDetailsPage.vue?vue&type=template&id=02f74699&scoped=true&"
import script from "./PartDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PartDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./PartDetailsPage.vue?vue&type=style&index=0&id=02f74699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f74699",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
